export enum IStatsActionTypes {
    GET_STATS_STEP1 = '@@statistics/GET_STATS_STEP1',
    GET_STATS_STEP1_SUCCESS = '@@statistics/GET_STATS_STEP1_SUCCESS',
    GET_STATS_STEP1_ERROR = '@@statistics/GET_STATS_STEP1_ERROR',
    
    GET_STATS_STEP2 = '@@statistics/GET_STATS_STEP2',
    GET_STATS_STEP2_SUCCESS = '@@statistics/GET_STATS_STEP2_SUCCESS',
    GET_STATS_STEP2_ERROR = '@@statistics/GET_STATS_STEP2_ERROR',

    GET_STATS_STEP3 = '@@statistics/GET_STATS_STEP3',
    GET_STATS_STEP3_SUCCESS = '@@statistics/GET_STATS_STEP3_SUCCESS',
    GET_STATS_STEP3_ERROR = '@@statistics/GET_STATS_STEP3_ERROR',

    GET_STATS_STEP4 = '@@statistics/GET_STATS_STEP4',
    GET_STATS_STEP4_SUCCESS = '@@statistics/GET_STATS_STEP4_SUCCESS',
    GET_STATS_STEP4_ERROR = '@@statistics/GET_STATS_STEP4_ERROR',

    GET_STATS_STEP5 = '@@statistics/GET_STATS_STEP5',
    GET_STATS_STEP5_SUCCESS = '@@statistics/GET_STATS_STEP5_SUCCESS',
    GET_STATS_STEP5_ERROR = '@@statistics/GET_STATS_STEP5_ERROR',

    GET_STATS_EVOLUTION_PER_MONTH = '@@statistics/GET_STATS_EVOLUTION_PER_MONTH',
    GET_STATS_EVOLUTION_PER_MONTH_SUCCESS = '@@statistics/GET_STATS_EVOLUTION_PER_MONTH_SUCCESS',
    GET_STATS_EVOLUTION_PER_MONTH_ERROR = '@@statistics/GET_STATS_EVOLUTION_PER_MONTH_ERROR',

    GET_STATS_EVOLUTION_PDF = '@@statistics/GET_STATS_EVOLUTION_PDF',
    GET_STATS_EVOLUTION_PDF_SUCCESS = '@@statistics/GET_STATS_EVOLUTION_PDF_SUCCESS',
    GET_STATS_EVOLUTION_PDF_ERROR = '@@statistics/GET_STATS_EVOLUTION_PDF_ERROR',

    RESET_STATISTICS = '@@statistics/RESET_STATISTICS',
}

export interface ITab {
    id:number,
    name: string
}

export const topTitles:ITab[] = [
    {
      id: 0,
      name: 'Equilibre général'
    },
    {
      id: 1,
      name: 'Partis Pol.'
    },
    {
      id: 2,
      name: 'Personnalités'
    },
    {
      id: 3,
      name: 'Médias'
    },
    {
      id: 4,
      name: 'Interventions'
    }
]

export interface IStatsFilters1 {
    mediasIds: number[],
    programTypesIds: number[],
    mediasStr: string[],
    programTypesStr: string[],
    startDate: Date,
    endDate: Date,
    show_pres: boolean
}
export interface IStatsFilters2 {
    political_regime_id: number,
    mediasIds: number[],
    programTypesIds: number[],
    startDate: Date,
    endDate: Date
}
export interface IStatsFilters3 {
    political_group_id: number,
    mediasIds: number[],
    programTypesIds: number[],
    startDate: Date,
    endDate: Date
}
export interface IStatsFilters4 {
    political_group_id: number,
    person_id: number,
    mediasIds: number[],
    programTypesIds: number[],
    startDate: Date,
    endDate: Date
}
export interface IStatsFilters5 {
    political_group_id: number,
    political_regime_id: number,
    program_type_ids: number[],
    person_id: number,
    media_id: number,
    startDate: Date,
    endDate: Date
}
export interface IStats1 {
    count_broadcast: number,
    duration_hms: string,
    duration_s: number,
    percent: string,
    political_regime_color: number,
    political_regime_id: number,
    political_regime_name: string
}
export interface IStats2 {
    count_broadcast: number,
    duration_hms: string,
    duration_s: number,
    percent: string,
    percents_100: string;
    political_group_color: number,
    political_group_id: number,
    political_group_name: string
}
export interface IStats3 {
    count_broadcast: number,
    duration_hms: string,
    duration_s: number,
    percent: string,
    person_id: number,
    person_name: string
}
export interface IStats4 {
    count_broadcast: number,
    duration_hms: string,
    duration_s: number,
    percent: string,
    media_id: number,
    media_name: string
}
export interface IStats5 {
    day: string,
    duration_hms: string,
    duration_s: number,
    editeur_id: number,
    editeur_name: string,
    media_id: number,
    media_name: string,
    person_id: number,
    person_name: string,
    political_group_id: number,
    political_group_name: string,
    time: string,
    typeemission_code: string,
    typeemission_id: number,
    typeemission_name: string
}
export interface IData1 {
    political_regime_name: string;
    count_broadcast: number;
    duration: string;
    percent: string;
    color: number;
    political_regime_id: number
}
export interface IData2 {
    political_group_name: string;
    count_broadcast: number;
    duration: string;
    percent: string;
    percents_100: string;
    color: number;
    political_group_id: number
}
export interface IGroupInfos {
    duration_hms: string,
    duration_s: number,
    libelle: string,
    percent: string,
    color: number
}
export interface IDatas {
    readonly [groupId:string]: IGroupInfos;
}
export interface IStatsEvolutionPerGroup {
    datas: IDatas;
    libelle: string;
    total_duration_s: number
}
export interface IStatsEvolutionPerMonth {
    readonly [yearMonth:string]: IStatsEvolutionPerGroup;
}
export interface IStatsEvolutionFilters {
    year: number,
    media_ids: number[],
    program_type_ids: number[],
    political_group_ids: number[],
    medias_str?: string[],
    programs_str?: string[]
}
export interface IStatsState {
    readonly statsStep1: IStats1[];
    readonly statsStep2: IStats2[];
    readonly statsStep3: IStats3[];
    readonly statsStep4: IStats4[];
    readonly statsStep5: IStats5[];
    readonly statsFilters1: IStatsFilters1 | null;
    readonly statsFilters2: IStatsFilters2 | null;
    readonly statsFilters3: IStatsFilters3 | null;
    readonly statsFilters4: IStatsFilters4 | null;
    readonly statsFilters5: IStatsFilters5 | null;
    readonly totalDurationS?: number;
    readonly periodTitle: string | undefined;
    readonly regimeName: string;
    readonly groupName: string;
    readonly personName: string;
    readonly mediaName: string;
    readonly regimeColor: number;
    readonly groupColor: number;
    readonly personColor: number;
    dataRegime: IData1[] | null;
    dataGroup: IData2[] | null;
    dataPerson: any;
    dataMedia: any;
    dataDay: IStats5[] | null;
    isLoading: boolean;
    isLoadingStats1: boolean;
    statsEvolutionFilters: IStatsEvolutionFilters | null;
    statsEvolutionPerMonth: IStatsEvolutionPerMonth | null;
    dataEvolutionPerMonth: any;
    activeTabNames: ITab[];
}
